var exports = {
  "tb": "UserProfileModal.module__noteTextarea___VUdlUn",
  "CR": "UserProfileModal.module__modalRoot___VUdlUn",
  "eF": "UserProfileModal.module__userInfo___VUdlUn",
  "hR": "UserProfileModal.module__userInfoHeader___VUdlUn",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___VUdlUn",
  "Rn": "UserProfileModal.module__userInfoContent___VUdlUn",
  "yn": "UserProfileModal.module__profileDataWarning___VUdlUn",
  "S7": "UserProfileModal.module__nameRow___VUdlUn",
  "nT": "UserProfileModal.module__userName___VUdlUn",
  "a1": "UserProfileModal.module__userTag___VUdlUn",
  "Fj": "UserProfileModal.module__usernameRow___VUdlUn",
  "hI": "UserProfileModal.module__pronouns___VUdlUn",
  "sM": "UserProfileModal.module__srOnly___VUdlUn",
  "Li": "UserProfileModal.module__customStatusText___VUdlUn",
  "Ef": "UserProfileModal.module__customStatusRow___VUdlUn",
  "_z": "UserProfileModal.module__tagBadgeRow___VUdlUn",
  "U3": "UserProfileModal.module__badgesWrapper___VUdlUn",
  "ZV": "UserProfileModal.module__userNoteEditor___VUdlUn",
  "xu": "UserProfileModal.module__noteLabel___VUdlUn",
  "_j": "UserProfileModal.module__noteTextareaBase___VUdlUn",
  "jd": "UserProfileModal.module__noteTextareaEditing___VUdlUn",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___VUdlUn",
  "bs": "UserProfileModal.module__profileContent___VUdlUn",
  "EM": "UserProfileModal.module__profileContentHeader___VUdlUn",
  "cI": "UserProfileModal.module__bannerContainer___VUdlUn",
  "HG": "UserProfileModal.module__bannerMask___VUdlUn",
  "_e": "UserProfileModal.module__bannerImage___VUdlUn",
  "N1": "UserProfileModal.module__headerContainer___VUdlUn",
  "H": "UserProfileModal.module__avatarContainer___VUdlUn",
  "fc": "UserProfileModal.module__actionButtonsContainer___VUdlUn",
  "hQ": "UserProfileModal.module__contentContainer___VUdlUn",
  "sq": "UserProfileModal.module__profileContentWrapper___VUdlUn",
  "zL": "UserProfileModal.module__scrollerFullHeight___VUdlUn",
  "jT": "UserProfileModal.module__modalContainer___VUdlUn",
  "uu": "UserProfileModal.module__actionButtons___VUdlUn",
  "iA": "UserProfileModal.module__buttonIcon___VUdlUn",
  "ro": "UserProfileModal.module__menuIcon___VUdlUn",
  "WB": "UserProfileModal.module__avatarFocusRing___VUdlUn",
  "VS": "UserProfileModal.module__tabsWrapper___VUdlUn",
  "OT": "UserProfileModal.module__mutualFriendsList___VUdlUn",
  "Z8": "UserProfileModal.module__mutualSectionDivider___VUdlUn",
  "KF": "UserProfileModal.module__mutualFriendItem___VUdlUn",
  "vu": "UserProfileModal.module__active___VUdlUn",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___VUdlUn",
  "D9": "UserProfileModal.module__mutualFriendInfo___VUdlUn",
  "eV": "UserProfileModal.module__mutualFriendName___VUdlUn",
  "zD": "UserProfileModal.module__mutualFriendUsername___VUdlUn",
  "p$": "UserProfileModal.module__emptyState___VUdlUn",
  "Ny": "UserProfileModal.module__mutualGuildIcon___VUdlUn",
  "me": "UserProfileModal.module__separator___VUdlUn",
  "AI": "UserProfileModal.module__emptyStateIcon___VUdlUn",
};

module.exports = exports;
